// Normalize on submission so formatting never interrupts typing or moves the cursor.
export function normalizeCheckoutPhone(value: string): string {
  const raw = value.trim();
  if (!raw) return "";
  const error = "Enter a 10-digit WhatsApp number, or include +country code";
  if (!/^\+?[0-9\s().-]+$/.test(raw)) throw new Error(error);
  let phone = raw.replace(/\D/g, "");
  const explicitCountry = raw.startsWith("+") || raw.startsWith("00");
  if (raw.startsWith("00")) phone = phone.slice(2);
  if (!explicitCountry) {
    if (phone.length === 11 && phone.startsWith("0")) phone = phone.slice(1);
    if (phone.length === 10) phone = "91" + phone;
    else if (phone.length < 10) throw new Error(error);
  }
  if (!/^[1-9]\d{7,14}$/.test(phone)) throw new Error(error);
  return phone;
}
